import { render, staticRenderFns } from "./GalileiView.vue?vue&type=template&id=29447fdc"
import script from "./GalileiView.vue?vue&type=script&lang=js"
export * from "./GalileiView.vue?vue&type=script&lang=js"
import style0 from "./GalileiView.vue?vue&type=style&index=0&id=29447fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports